class TobaccoBannerController {
    constructor(settings, breakpointsService) {
        this.settings = settings;
        this.breakpointsService = breakpointsService;
    }

    $onInit() {
        this.imagePath = this.breakpointsService.isSmallFormat()
            ? this.settings.banners.tobaccoSmall
            : this.settings.banners.tobaccoDefault;
    }
}

const tobaccoBannerComponentDefinition = {
    controller: ['Settings', 'BreakpointsService', TobaccoBannerController],
    template: require('./tobacco-banner.component.html').trim(),
};

module.exports = {
    TobaccoBannerController,
    tobaccoBannerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/banners/tobacco-banner.component.js